var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKeyboardArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 11.899 12)",
    fill: "#000000",
    d: "m15.79999,9l-3.90003,3.90002l-3.89996,-3.90002c-0.36847,-0.3866 -0.98053,-0.40137 -1.36713,-0.03284c-0.01123,0.01062 -0.02221,0.02161 -0.03289,0.03284c-0.3866,0.36841 -0.40131,0.98059 -0.03284,1.36719c0.01068,0.01123 0.02161,0.02209 0.03284,0.03283l4.59997,4.59998c0.36847,0.3866 0.98053,0.40137 1.36713,0.03284c0.01123,-0.01062 0.02221,-0.02161 0.0329,-0.03284l4.59997,-4.59998c0.39099,-0.3822 0.39807,-1.00903 0.01587,-1.40002s-1.00897,-0.39807 -1.39996,-0.01587c-0.00537,0.00525 -0.01062,0.0105 -0.01587,0.01587z",
    className: "st0",
    id: "Icon_Keyboard_Arrow_-_Down_Rounded"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/Icon_KeyboardArrowUp.4e4c2294e9dea4c4f8ba5d59f4977034.svg";
export { ForwardRef as ReactComponent };